import { Link } from 'react-router-dom';
import PageShell from '@/components/feature/PageShell';
import PageIntro from '@/components/feature/PageIntro';
import FinalCta from '@/components/feature/FinalCta';
import Container from '@/components/base/Container';
import ExposureResolve from '@/components/base/ExposureResolve';
import { services, serviceCutouts } from '@/mocks/services';

export default function ServicesPage() {
  return (
    <PageShell>
      <PageIntro eyebrow="All Services" title="Appliance Repair Services">
        Five categories, one careful approach: diagnose properly, explain clearly, repair well.
      </PageIntro>
      <section className="bg-background-50 pb-20 md:pb-32">
        <Container>
          {services.map((s, i) => (
            <Link
              key={s.slug}
              to={`/services/${s.slug}`}
              className="mw-row mw-trace group grid grid-cols-1 items-center gap-6 border-t border-background-200 py-8 md:py-10 sm:grid-cols-[180px_1fr] lg:grid-cols-[80px_220px_1fr_auto] lg:gap-12 last:border-b"
            >
              <span className="hidden lg:block text-xs text-foreground-600">{`0${i + 1}`}</span>
              <ExposureResolve className="h-[220px] sm:h-[200px] lg:h-[240px] w-full overflow-hidden">
                <img src={serviceCutouts[s.slug] || s.image} alt={s.name} title={`${s.name} - MENDWELL`} className="h-full w-full object-contain object-center p-5 md:p-6" />
              </ExposureResolve>
              <div>
                <h2 className="text-2xl md:text-[32px] font-light tracking-tight text-foreground-950 group-hover:text-primary-600 transition-colors">{s.name}</h2>
                <p className="mt-3 max-w-lg text-sm md:text-[15px] leading-relaxed text-foreground-600">{s.summary}</p>
              </div>
              <span className="hidden lg:flex h-11 w-11 items-center justify-center rounded-full border border-background-200 text-primary-600 group-hover:bg-primary-500 group-hover:text-white group-hover:border-primary-500 mw-btn">
                <i className="ri-arrow-right-line mw-arrow" />
              </span>
            </Link>
          ))}
        </Container>
      </section>
      <FinalCta />
    </PageShell>
  );
}